import { PencilBoxMultipleOutlineIcon } from './PencilBoxMultipleOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 071E2A53-1647-4747-98BE-A7787AF39C15
 * name pencil-box-multiple-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pencil-box-multiple-outline.svg
 * tags
 * - Edit / Modify 
 */
export const LibraryEditOutlineIcon = PencilBoxMultipleOutlineIcon;
export default LibraryEditOutlineIcon